import { envVars } from '../../helpers';

export const BREVO_ID = envVars(
  'NEXT_PUBLIC_BREVO_CLIENT_KEY',
  process.env.NEXT_PUBLIC_BREVO_CLIENT_KEY
)
  .required()
  .asString();
